module.exports = __webpack_public_path__ + "img/70.b325871d.jpg";